// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonContextMenu_position{
    position: fixed;
    z-index: 1;
}

.commonContextMenu{
    display: flex;
    flex-direction: column;
    gap: 1px;
    background: #FFFFFF;
    box-shadow: 0px 4px 58px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    padding: 10px 0px;
    width: fit-content;
    opacity: 1;
}

.commonContextMenu--hide{
    opacity: 0;
    transition-delay: 100ms;
}

.commonContextMenu--main{
    position: absolute;
}

.commonContextMenu--rt{
    right: 0;
    top: 0;
}

.commonContextMenu--rb{
    right: 0;
    bottom: 0;
}

.commonContextMenu--lt{
    left: 0;
    top: 0;
}

.commonContextMenu--lb{
    left: 0;
    bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/commonContextMenu/commonContextMenu.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,OAAO;IACP,MAAM;AACV;;AAEA;IACI,OAAO;IACP,SAAS;AACb","sourcesContent":[".commonContextMenu_position{\n    position: fixed;\n    z-index: 1;\n}\n\n.commonContextMenu{\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 58px rgba(0, 0, 0, 0.15);\n    border-radius: 12px;\n    padding: 10px 0px;\n    width: fit-content;\n    opacity: 1;\n}\n\n.commonContextMenu--hide{\n    opacity: 0;\n    transition-delay: 100ms;\n}\n\n.commonContextMenu--main{\n    position: absolute;\n}\n\n.commonContextMenu--rt{\n    right: 0;\n    top: 0;\n}\n\n.commonContextMenu--rb{\n    right: 0;\n    bottom: 0;\n}\n\n.commonContextMenu--lt{\n    left: 0;\n    top: 0;\n}\n\n.commonContextMenu--lb{\n    left: 0;\n    bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
